import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a712b248295d50014b9d503_1785958792294_4625cf1b/medstaff/src/app/hiring/page.tsx");
